import { Component } from '@angular/core';
import { PopupTemplateContainerService } from './popup-template-container.service';
import { TemplateObject } from './interfaces';

@Component({
    selector: 'aza-rws-popup-template-container',
    templateUrl: './popup-template-container.component.html',
    styleUrls: ['./popup-template-container.component.scss'],
    standalone: false
})
export class PopupTemplateContainerComponent {
    templates$ = this.popupContainerSvc.templates$;

    constructor(private popupContainerSvc: PopupTemplateContainerService) {}

    templateTrackBy = (index: number, template: TemplateObject<any>) => {
        return this.templateMenuTrackBy(template);
    };

    private templateMenuTrackBy = (template: TemplateObject<any>) => {
        return `${template.type}-${template.identifier}`;
    };
}
